module.exports = __webpack_public_path__ + "static/media/TZ.15fc3a0e.svg";